import { Component, OnInit, Inject, Input,ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { first } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { CashierService } from '../addfund-popup/cashier.service';
import { MainService } from '../_services/main.service';
import { PhoneVerificationComponent } from 'src/app/phone-verification/phone-verification.component';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { AuthUserData } from '../store/actions/appActions';
import { environment } from 'src/environments/environment';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit{
  @ViewChild('qrCanvas') qrCanvas!: ElementRef;
  verificationFrom:FormGroup;
  uploadDocForm:FormGroup;
  user_id:any;
  currentUser: any;
  userData: any;
  sub_submitDoc : any;
  sub_tsevoVerification : any;
  sub_stateList : any;
  phoneVerificationRef: MatDialogRef<PhoneVerificationComponent>;
  verificatioSubmitted = false;
  uploadDocSubmitted = false;
  imageSrc:string | ArrayBuffer;
  showUploadIdSuccessBox=false;
  showUploadBtn =false;
  isMobile = false;
  dateList = [];
  monthList = [{'key':'1','value':'Jan'},{'key':'2','value':'Feb'},{'key':'3','value':'Mar'},{'key':'4','value':'April'},{'key':'5','value':'May'},{'key':'6','value':'Jun'},{'key':'7','value':'Jul'},{'key':'8','value':'Aug'},{'key':'9','value':'Sep'},{'key':'10','value':'Oct'},{'key':'11','value':'Nov'},{'key':'12','value':'Dec'}];
  yearList = [];
  countryList = [{'name':'Canada','code':'CA','id':'38'},{'name':'United States','code':'US','id':'224'}];
  stateList = [];
  hideAlert= false;
  uploadTab= false;
  selectedFile = null;
  parentPage = 'Join';
  isDisable = false;
  isSubmitting: boolean = false;
  isQrcode:boolean = false;
  assetURL : string = `${environment.assetURL}`;
  deviceType : string = '';
  @Input() page: any; // decorate the property with @Input()
  @Input() user: any; // decorate the property with @Input()
  @Input() ipAddress: any;
  @Input() darkMode: boolean;
  @Input() isAwareVerification: boolean;
  constructor(public _cashierService: CashierService,private _appService: MainService, private formBuilder: FormBuilder,private spinner: NgxSpinnerService,  public datepipe: DatePipe, private _flashMessagesService: FlashMessagesService, private deviceService: DeviceDetectorService, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data,public store: Store<AppState>) {
     if(data && data.user)this.userData = data.user;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
    }
    this.isMobile = this.deviceService.isMobile();
    this.deviceType = this.deviceService.os;
  }
  get v() { return this.verificationFrom.controls; }
  ngOnInit() {
    this.isQrcode = false;
    this.verificationFrom = this.formBuilder.group({
      user_id: [this.user_id],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      dd: ['', Validators.required],
      mm: ['', Validators.required],
      yyyy: ['', Validators.required],
      EmailAddress: ['', [Validators.required,Validators.email]],
      phoneNumber: ['', [Validators.required,Validators.minLength(12),Validators.maxLength(14)]],
      AddressLine1: ['', Validators.required],
      AddressLine2: [''],
      city: ['', Validators.required],
      PostalCode: ['', Validators.required],
      CountryCode: ['', Validators.required],
      StateCode: ['', Validators.required],
      ipAddress:[this.ipAddress]
    });
    this.uploadDocForm = this.formBuilder.group({
      user_id: [this.user_id],
      document: ['', Validators.required],
      image: ['', Validators.required],
      file_name: ['', Validators.required],
    });
    if(this.userData.id != null && this.user_id > 0) {
      if(this.isAwareVerification == undefined) this.isAwareVerification = this.userData['verification_method'] == 'aware' ? true : false;
      this.setFormData();
    } else {
      this.getUserData();
    }
    this.dateList = [];
    this.yearList = [];
    for (let index = 1; index <= 31; index++) {
      this.dateList.push({'key':index.toString(),'value':index})
    }
    for (let index = Number(this.datepipe.transform(Date.now(), 'y')); index >= 1905; index--) {
      this.yearList.push({'key':index.toString(),'value':index})
    }
  }
  
  showQrcodeOld(){
    this.isQrcode = true;
    this.spinner.show();
    this._cashierService.kycVerification().subscribe(data => {
    this.spinner.hide();
    if(data && data.status == "success"){
      const canvas = this.qrCanvas.nativeElement;
      const option = { 
        Default:'H',
        errorCorrectionLevel: 'H',
        width: 200,
      }
      QRCode.toCanvas(canvas, `${environment.phpUrl}/kyc_verification?otp=${data.otp}`,option, function (error) {
        if (error) console.error(error);
        console.log('QR code generated!');
      });
     }
    });
  }
  
   showQrcode(){
    this.isQrcode = true;
    this.spinner.show();
    setTimeout(()=>{
      this.spinner.hide();
      const canvas = this.qrCanvas.nativeElement;
      const option = { 
        Default:'H',
        errorCorrectionLevel: 'H',
        width: 200,
      }
      const url = 'https://app2.drafters.info/uC18';
      QRCode.toCanvas(canvas,url,option, function (error) {
        if (error) console.error(error);
        console.log('QR code generated!');
      });
    },500)
  }
  
  ngOnChanges(e) {
    // need to detect input changes for user, parentPage
    this.userData = e.user.currentValue;
    this.parentPage = e.page.currentValue;
    this.user_id = this.userData.id;
  }

  getUserData(){
    this.spinner.show();
    this._appService.userDetail().subscribe(data=>{
      if(data['status'] === 'success') {
        this.userData = data['entities'];
        if(this.isAwareVerification == undefined) this.isAwareVerification = this.userData['verification_method'] == 'aware' ? true : false;
        this.setFormData();
      }
      this.spinner.hide();
    });
  }

  setFormData() {
    if(this.userData){
      const dob = this.userData.dob.split('-');
      const dd  = Number((dob[2])?dob[2]:'');
      const mm  = Number((dob[1])?dob[1]:'');
      const yy  = Number((dob[0])?dob[0]:''); 
      this.v['dd'].setValue(dd.toString());
      this.v['yyyy'].setValue(yy.toString());
      this.v['mm'].setValue(mm.toString());
      this.v['EmailAddress'].setValue(this.userData.email);
      this.v['AddressLine1'].setValue(this.userData.address);
      this.v['city'].setValue(this.userData.hometown);
      this.v['PostalCode'].setValue(this.userData.zip_code);
      this.v['phoneNumber'].setValue(this.userData.primary_number);
      let currentTime = Math.floor(new Date().getTime()/1000);
      let diff = currentTime - this.userData.doc_upload_time;
      let min = (diff > 0) ? diff/60 : 0;
      this.showUploadIdSuccessBox = (this.userData.doc_upload == 1) ? true : false;
    }
  }

  onVerificationSubmit(el:HTMLElement){
    this.verificatioSubmitted = true;
    // stop here if form is invalid
    if (this.verificationFrom.invalid) {
      return;
    } else {
      this.spinner.show();
      this.isDisable = true;
      this.sub_tsevoVerification = this._cashierService.tsevoVerification(this.verificationFrom.value).pipe(first()).subscribe(
        data => {
          this.verificatioSubmitted = false;
          this.isDisable = false;
          this.spinner.hide();
          if(data != null) {
            if(data.status == "success") {
              this.hideAlert = true;
              this._flashMessagesService.show(data.message, { cssClass: 'alert-success',timeout: 10000,showCloseBtn:true });
              el.scrollIntoView();
            } else {
              this.userData.verification_attempts++;
            }
            if(this.v.phoneNumber.value && this.userData.verify_phone != null && this.userData.verify_phone == 'N' && environment.IS_PHONE_VERIFICATION) {
              setTimeout(()=>{
                //Phone number not verified?
                this.phoneVerificationRef =  this.dialog.open(PhoneVerificationComponent, {
                  width: '500px',
                  data: {phoneNumber: this.v.phoneNumber.value}
                });
                this.phoneVerificationRef.afterClosed().subscribe(res => {
                  if (res.verify_phone) {
                    this.v['phoneNumber'].setValue(this.formatPhone(res.primary_number));
                    this.userData.verify_phone = res.verify_phone;
                    this.userData.primary_number = res.primary_number;
                  }
                });
              },2000);
            }
          } else {
            this.hideAlert = true;
            this._flashMessagesService.show('Something went wrong! Please try again', { cssClass: 'alert-danger',timeout: 10000,showCloseBtn:true } );
            setTimeout(()=>{this.hideAlert = false;},10010)
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  onSelectFile(files) {
    const file1: File = files[0];
    var file = file1;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = e => this.imageSrc = reader.result;
    reader.readAsDataURL(file);
    this.uploadDocForm.get('file_name').setValue(file.name);
    this.uploadDocForm.get('image').setValue(files[0]);   
    this.selectedFile = files[0];
    this.showUploadBtn = true;
  }

  changeVerificationstatus(){
    this.userData.payment_verified = "Y";
    this.store.dispatch(new AuthUserData(
      this.userData.payment_verified
    ));
  }
  onDocSubmit(){
    this.uploadDocSubmitted = true;
    // stop here if form is invalid
    if (this.uploadDocForm.invalid) {
      return;
    } else {
      this.isSubmitting = true;
      this.spinner.show();   
      let form = new FormData();  
      form.append('document',this.selectedFile, this.selectedFile.name);
      form.append('login_user_id',this.currentUser.id); 
      this.sub_submitDoc = this._cashierService.submitVerificationDocument(form).pipe(first()).subscribe(
        data => {
          this.isSubmitting = false;
          this.spinner.hide();
          if(data != null) {
            if (data.status === 'success') {
              this.userData.doc_upload  = 1;
              this.showUploadIdSuccessBox = true;
              this.userData.doc_upload_time =Math.floor(new Date().getTime()/1000);
              this.resetFile();
              this._flashMessagesService.show(data.message, { cssClass: 'alert-success',timeout: 10000,showCloseBtn:true } );
              this.changeVerificationstatus();
              if(this.data.lobby){
                window.location.href = `${environment.SITE_URL}/drafts/register/welcome`;
              }
            } else {
              this._flashMessagesService.show(data.message, { cssClass: 'alert-danger',timeout: 10000,showCloseBtn:true } );
            }
          } else {
            this._flashMessagesService.show('Something went wrong! Please try again', { cssClass: 'alert-danger',timeout: 10000,showCloseBtn:true } );
          }
        },
        error => {
          this.isSubmitting = false;
          this.spinner.hide();
          console.log(error);
        });
    }
  }

  getStateList(country_code){
    const country  = this.countryList.find(x=>(x.code == country_code));
    this.sub_stateList = this._cashierService.stateList(country.id).subscribe(res=>{
      if(res.status === 'success'){
        this.stateList  = res.entities;
      }
    });
  }

  uploadDocAction(action){
    if(action=='change')
    this.uploadTab = true;
    else
    this.hideAlert = true
  }

  resetFile() {
    this.imageSrc = null;
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    const phonel:string = this.v.phoneNumber.value; 
    const inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode !== 8 && !pattern.test(inputChar)) || phonel.length > 11) {
      event.preventDefault(); 
    }else{ 
      const countNumber = (this.v.phoneNumber.value)?phonel.length:0; 
      if(countNumber === 3 || countNumber === 7){
        const phone_number = this.v.phoneNumber.value+'-';
        this.v['phoneNumber'].setValue(phone_number);
      }
    }
  }

  formatPhone(phone:any) {
    if(phone) {
      phone = phone.replace('+1 ','');
      phone = phone.replace(/-/g,'');
      const b = '-';
      const position1 = 3;
      const position2 = 6;
      return [phone.slice(0, position1), b, phone.slice(position1, position2), b, phone.slice(position2)].join('');
    } else {
      return ;
    }
  }
}
